import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LandingRedirectComponent} from './landing-redirect.component';
import {RoleRedirectGuard} from '../../../../../auth/keycloak-role-redirect.guard';

const routes: Routes = [
    {
        path: '',
        component: LandingRedirectComponent,
        canActivate: [RoleRedirectGuard]
    }
];

@NgModule({
    declarations: [],
    imports: [
        RouterModule.forChild(routes),
    ],
    providers: []
})
export class LandingRedirectModule {
}
